import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

interface NavTabEntry {
  label: string;
  slug: string;
}

interface Props {
  value: string;
  tabs: ReadonlyArray<NavTabEntry>;
  buildHref: (slug: string) => string;
}

/**
 * Horizontal scrollable tab bar used for the main Commercial Ops nav and every
 * sub-nav under it. Encapsulates the visual styling (bordered bottom, min-width
 * tabs, scroll buttons) so both levels stay in sync.
 */
export default function NavTabs({ value, tabs, buildHref }: Props) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={value} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab) => (
          <Tab
            key={tab.slug}
            value={tab.slug}
            label={tab.label}
            to={buildHref(tab.slug)}
            component={Link}
            sx={{ minWidth: 30, padding: '12px 10px' }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
